import { memo } from 'react'

import { useFeature } from '../model/useFeature.tsx'
import { FeatureElementProps } from '../types/FeatureElementProps.ts'
import { FeatureButton } from './FeatureButton'
import { FeatureClickableButton } from './FeatureClickableButton'
import { FeatureIcon } from './FeatureIcon.tsx'

export const ComparisonFeatureElement = memo(
	({
		feature,
		onClick,
		forceIsClickable,
		showSelectedOption = true,
		showFeatureName = false,
		disableIcon = true
	}: FeatureElementProps) => {
		const { label, tooltipInfo, iconValues, isClickable, isExist } = useFeature(
			feature,
			showSelectedOption,
			showFeatureName,
			forceIsClickable
		)

		// TODO: We should refactor feature components to support asChild prop. e.g. we should be able to wrap FeatureClickableButton in TooltipTrigger
		// TODO: We should also fix styles for feature tooltip, currently they're inconsistent and tooltips are messing up horizontal alignment of features
		return (
			<div className="flex size-full items-center justify-center px-2 py-1 sm:px-4 sm:py-2">
				<div className="flex h-8 items-center justify-center gap-2">
					{isClickable ? (
						<FeatureClickableButton
							data-wwt-id="feature-comparison--button"
							iconValues={iconValues}
							isExist={isExist}
							onClick={onClick}
							disableIcon={disableIcon}
							tooltipInfo={tooltipInfo}
						>
							{label}
						</FeatureClickableButton>
					) : (
						<>
							{!disableIcon && <FeatureIcon {...iconValues} />}
							<FeatureButton
								className="line-clamp-1 sm:line-clamp-2"
								data-wwt-id="feature-comparison--button"
								iconValues={iconValues}
								tooltipInfo={tooltipInfo}
							>
								{label}
							</FeatureButton>
						</>
					)}
				</div>
			</div>
		)
	}
)

ComparisonFeatureElement.displayName = 'ComparisonFeatureElement'
